
import UtilsUrl from "../utils/UtilsUrl";
import api from "./api";



class KPISaleService {
  getToByYear(idUserCreation, year) {
    return api.get(
      UtilsUrl.KpiSaleURL() +
      "/getToByYear/" +
      idUserCreation +
      "/" +
      year
    );
  }

  getProductsSaleByMonthByYear(idUserCreation, month, year,clientId) {
    return api.get(
      UtilsUrl.KpiSaleURL() +
      "/getProducts/" +
      idUserCreation +
      "/" +
      month +
      "/" +
      year +
      "/" +
      clientId
    );
  }

  getBDCToByYear(idUserCreation, year) {
    return api.get(
      UtilsUrl.KpiSaleURL() +
      "/getToBDCByYear/" +
      idUserCreation +
      "/" +
      year
    );
  }

  numberFacturePayed(idUserCreation, year) {
    return api.get(
      UtilsUrl.KpiSaleURL() +
      "/numberFacturePayed/" +
      idUserCreation +
      "/" +
      year
    );
  }

  numberDevisMonthsInYear(idUserCreation, year) {
    return api.get(
      UtilsUrl.KpiSaleURL() +
      "/numberDevisMonthsInYear/" +
      idUserCreation +
      "/" +
      year
    );
  }

  numberBDCMonthsInYear(idUserCreation, year) {
    return api.get(
      UtilsUrl.KpiSaleURL() +
      "/numberBDCMonthsInYear/" +
      idUserCreation +
      "/" +
      year
    );
  }

  getPayementsByYear(idBa, idUserCreation, year, typePayementValidation, type) {
    return api.get(
      UtilsUrl.KpiSaleURL() +
      "/getPayementsByYear/" + idBa +
      "/" +
      idUserCreation +
      "/" +
      year +
      "/" +
      typePayementValidation +
      "/" +
      type
    );
  }
  getAllPayementsByYear(idBa, idUserCreation, year, typePayementValidation, type) {
    return api.get(
      UtilsUrl.KpiSaleURL() +
      "/getAllPayementsByYear/" + idBa +
      "/" +
      idUserCreation +
      "/" +
      year +
      "/" +
      typePayementValidation +
      "/" +
      type
    );
  }

  getPayementsByBankAccountAndYear(idBa, idUserCreation, year) {
    return api.get(
      UtilsUrl.KpiSaleURL() +
      "/getPayementsByBankAccountAndYear/" + idBa +
      "/" +
      idUserCreation +
      "/" +
      year
    );
  }

}
export default new KPISaleService();